<template>
  <div class="chart-container">
    <div class="Hcp-main-header">
      <div class="main-header-left">
        <span>{{$t('TrendAna')}}</span>
      </div>
      <div class="main-header-right">
        <button @click="print"><span>{{$t('print')}}</span></button>
        <button class="set" @click="open"><span>{{$t('set')}}</span></button>
        <p>{{$t('period')}}:<span class="time">{{timeRange}}</span></p>
      </div>
    </div>
    <hr class="small-hr spe-hr">
    <div  >
    <el-row>
      <el-col :span="24">
        <div id="chart4_1" class="graph" :element-loading-text="loadingText"  v-loading="loading"></div>

        <div class="statics">
          <p>{{$t('static')}}</p>
          <table class="statics-table" >
            <tr>
              <td rowspan="2" width="9%" class="td1">{{$t('static')}}</td>
              <td colspan="10" width="29%" class="td1">{{$t('Basics')}}</td>
              <td colspan="3"  class="td1">{{$t('distri')}}%</td>
              <td colspan="4" width="20%"  class="td1">{{$t('stab')}}</td>
              <td colspan="7" class="td2">{{$t('BG1')}}</td>
            </tr>
            <tr>
              <td class="td2">{{$t('Avg')}}</td> <td class="td2">{{$t('max')}}</td> <td class="td2">{{$t('min')}}</td> <td class="td2">{{$t('Med')}}</td>
              <td class="td2">{{$t('Q1')}}</td><td class="td2">{{$t('Q3')}}</td> <td class="td2">{{$t('IQR')}}</td><td class="td2">{{$t('SD')}}</td>
              <td  class="td2">{{$t('CV')}}</td> <td class="td1">{{$t('SE1')}}</td><td class="td2">{{$t('high')}}</td> <td class="td2">{{$t('low')}}</td>
              <td class="td1">{{$t('target')}}</td><td class="td2">{{$t('aucAbove')}}</td><td class="td2">{{$t('aucBelow')}}</td>
              <td class="td2">{{$t('#high')}}</td><td class="td1">{{$t('#low')}}</td><td class="td2">{{$t('high')}}%</td>
              <td class="td2">{{$t('low')}}%</td><td class="td1">{{$t('target')}}%</td>
              <td class="td2">{{$t('Avg')}}</td> <td class="td2">{{$t('SD')}}</td><td class="td2">{{$t('#hypo')}}</td><td class="td2">{{$t('bgRead')}}</td>
            </tr>
            <tr v-for="(day,j) in xDate2">
              <td class="td1">{{day}}</td>
              <td class="td2">{{glucose[j].sg_avg}}</td><td class="td2">{{glucose[j].sg_max}}</td><td class="td2">{{glucose[j].sg_min}}</td><td class="td2">{{glucose[j].sg_median}}</td>
              <td class="td2">{{glucose[j].sg_q1}}</td><td class="td2">{{glucose[j].sg_q3}}</td><td class="td2">{{glucose[j].sg_iqr}}</td><td class="td2">{{glucose[j].sg_sd}}</td>
              <td class="td2">{{glucose[j].sg_cv}}</td><td class="td1">{{glucose[j].sg_se}}</td>
              <td class="td2">{{glucose[j].sg_up}}</td>  <td class="td2">{{glucose[j].sg_lp}}</td><td class="td1">{{glucose[j].sg_tp}}</td>
              <td class="td2">{{glucose[j].sg_aucu}}</td><td class="td2">{{glucose[j].sg_aucl}}</td><td class="td2">{{glucose[j].sg_nu}}</td><td class="td1">{{glucose[j].sg_nl}}</td>
              <td class="td2">{{glucose[j].bg_up}}</td><td class="td2">{{glucose[j].bg_lp}}</td><td class="td1">{{glucose[j].bg_tp}}</td>
              <td class="td2">{{glucose[j].bg_avg}}</td><td class="td2">{{glucose[j].bg_sd}}</td><td class="td2">{{glucose[j].bg_hypo_num}}</td><td class="td2">{{glucose[j].bg_num}}</td>
            </tr>
            <tr>
              <td class="td3">{{$t('Avg/Total')}}</td>
              <td>{{glucose[dayNum].sg_avg}}</td><td>{{glucose[dayNum].sg_max}}</td><td>{{glucose[dayNum].sg_min}}</td><td>{{glucose[dayNum].sg_median}}</td>
              <td>{{glucose[dayNum].sg_q1}}</td><td>{{glucose[dayNum].sg_q3}}</td><td>{{glucose[dayNum].sg_iqr}}</td><td>{{glucose[dayNum].sg_sd}}</td>
              <td>{{glucose[dayNum].sg_cv}}</td><td class="td3">{{glucose[dayNum].sg_se}}</td>
              <td>{{glucose[dayNum].sg_up}}</td><td>{{glucose[dayNum].sg_lp}}</td><td class="td3">{{glucose[dayNum].sg_tp}}</td>
              <td>{{glucose[dayNum].sg_aucu}}</td><td>{{glucose[dayNum].sg_aucl}}</td><td>{{glucose[dayNum].sg_nu}}</td><td class="td3">{{glucose[dayNum].sg_nl}}</td>
              <td>{{glucose[dayNum].bg_up}}</td><td>{{glucose[dayNum].bg_lp}}</td><td class="td3">{{glucose[dayNum].bg_tp}}</td>
              <td>{{glucose[dayNum].bg_avg}}</td><td>{{glucose[dayNum].bg_sd}}</td><td>{{glucose[dayNum].bg_hypo_num}}</td><td>{{glucose[dayNum].bg_num}}</td>
            </tr>
          </table>
        </div>

        <div id="chart4_2" class="graph"></div>

        <div class="statics spe-statics">
          <p>{{$t('static')}}</p>
          <table class="statics-table" :class="{'de2':isDe}">
            <tr>
              <td rowspan="2" width="11%" class="td1">{{$t('static')}}</td>
              <td colspan="5"  class="td1">{{$t('insulin2')}}</td>
              <td colspan="2"  class="td1">{{$t('carbs')}}</td>
              <td colspan="2" class="td2">{{$t('exercise')}}</td>
            </tr>
            <tr>
              <td class="td1">{{$t('total')}} {{$t('ins_unit')}}</td> <td class="td1">{{$t('avg_daily_basal')}}</td> <td class="td1">{{$t('avg_daily_bolus')}}</td> <td class="td1">{{$t('ofBolus')}}</td> <td class="td1">{{$t('avgBolus')}}</td>
              <td class="td1">{{$t('carbs')}} (g)</td> <td class="td1">{{$t('ofMeal')}}</td><td class="td1">{{$t('Dura1')}}</td><td  class="td2">{{$t('ofExer')}}</td>
            </tr>
            <tr v-for="(day,i) in xDate2">
              <td class="td1">{{day}}</td>
              <td class="td1">{{event[i].ins_total}}</td>
              <td class="td1">
                <span class="value_percent_cell left_value">{{event[i].ins_basal}}</span>
                <span class="value_percent_cell right_percent">{{event[i].ins_basal_p}}</span>
              </td>
              <td class="td1">
                <span class="value_percent_cell left_value">{{event[i].ins_bolus}}</span>
                <span class="value_percent_cell right_percent">{{event[i].ins_bolus_p}}</span>
              </td>
              <td class="td1">{{event[i].ins_bolus_n}}</td>
              <td class="td1">{{event[i].ins_bolus_avg}}</td><td class="td1">{{event[i].carb_gram}}</td><td class="td1">{{event[i].carb_num}}</td>
              <td class="td1">{{event[i].exer_time}}</td><td class="td2">{{event[i].exer_num}}</td>
            </tr>
            <tr>
              <td class="td3">{{$t('Avg/Total')}}</td>
              <td class="td3">{{event[dayNum].ins_total}}</td>
              <td class="td3">
                <span class="value_percent_cell left_value">{{event[dayNum].ins_basal}}</span>
                <span class="value_percent_cell right_percent">{{event[dayNum].ins_basal_p}}</span>
              </td>
              <td class="td3">
                <span class="value_percent_cell left_value">{{event[dayNum].ins_bolus}}</span>
                <span class="value_percent_cell right_percent">{{event[dayNum].ins_bolus_p}}</span>
              </td>
              <td class="td3">{{event[dayNum].ins_bolus_n}}</td><td class="td3">{{event[dayNum].ins_bolus_avg}}</td><td class="td3">{{event[dayNum].carb_gram}}</td>
              <td class="td3">{{event[dayNum].carb_num}}</td><td class="td3">{{event[dayNum].exer_time}}</td><td>{{event[dayNum].exer_num}}</td>
            </tr>
          </table>
        </div>
        <br/><br/>
        <!--<div id="chart4_3" class="graph"></div>
        <div id="chart4_4" class="graph"></div>-->
      </el-col>
    </el-row>
    </div>
    <!--Add对话框-->
    <el-dialog  :visible.sync="typeChooseVisible" :size=dialogSize id="dialog-form2" :show-close="false">
      <div slot="title" class="patientList-dialog-title">
        <span>{{$t('setPeriod')}}</span>
        <img src="../../assets/cancel.png" @click="cancel">
      </div>
      <div slot class="dialog-body">
        <div class="select-interval-wrap">
          <!--  -->
          <p> {{$t('duration')}}</p>
          <select class="select-timerange" v-model="timeRangeSelect"
                  id="timeRangeSelect" @change="procTimeRangeSelect">
            <!--<option  value=1>7天</option>
            <option  value=2>14天</option>
            <option  value=3>30天</option>
            <option  value=4>90天</option>
            <option  value=0>自定义</option>-->
            <option value=1>{{$t('7 days')}}</option>
            <option value=2>{{$t('14 days')}}</option>
            <option value=3>{{$t('30 days')}}</option>
            <option value=4>{{$t('90 days')}}</option>
            <option value=0>{{$t('Customize')}}</option>
          </select>

          <p> {{$t('interval')}}</p>
          <select class="select-interval" v-model="timeIntervalSelect"
                  id="timeIntervalSelect" @change="procTimeIntervalSelect">
            <!--<option  value=1>天</option>
            <option  value=2>周</option>-->
            <option v-for="item in intervalOption" :value="item[0]">{{item[1]}}</option>
          </select>
          <div style="clear: both"></div>
        </div>
        <div class="time-range" :class="{'zh2':!isEn}">
          <p>{{$t('From')}}</p>

          <div class="date">
            <!-- 日期组件 editable 属性表示，文本框是否可以输入， 这里不允许输入 -->
            <el-date-picker v-model="value2" type="date"  :editable=false   :disabled="startDateDisable" :picker-options="pickerOptions"
                            :clearable=false   :placeholder="startDate"  @change="startDateChange"  format="dd-MM-yyyy">
            </el-date-picker>
          </div>
          <p>{{$t('To')}}</p>
          <div class="block">
            <el-date-picker v-model="value1" type="date"  :editable=false    :picker-options="pickerOptions"
                            :clearable=false   :placeholder="defaultDate"  @change="endDateChange"  format="dd-MM-yyyy">
            </el-date-picker>
          </div>
        </div>
        <hr class="patientList-small-hr">
        <div class="weeks" id="weeks" :class="{'zh3':!isEn}">
          <span class="tittle" :class="{'zh4':!isEn}"><label @click="chooseAll" >{{$t('Weekdays')}}</label></span>
          <span><label @click="choose" >{{$t('Mon')}}</label></span>
          <span><label @click="choose">{{$t('Tue')}}</label></span>
          <span><label @click="choose">{{$t('Wed')}}</label></span>
          <span><label @click="choose">{{$t('Thur')}}</label></span>
          <span><label @click="choose">{{$t('Fri')}}</label></span>
        </div>
        <div class="weeks weken" id='weken' :class="{'zh3':!isEn}">
          <span class="tittle" :class="{'zh5':!isEn,'de5':isDe,'it5':isIt,'po5':isPo,'du5':isDu,'sw5':isSw,'cz5':isCz}"><label @click="chooseAll" >{{$t('Weekends')}}</label></span>
          <span><label @click="choose">{{$t('Sat')}}</label></span>
          <span :class="{'it2':isIt,'po2':isPo,'du2':isDu,'fr3':isFr,'sw2':isSw,'cz2':isCz}"><label @click="choose">{{$t('Sun')}}</label></span>
        </div>
        <hr class="patientList-small-hr">
      </div>
      <div slot="footer" class="dialog-footer">
        <button @click="dateApply">{{$t('applyM')}}</button>
        <button  class="cancelButton" @click="cancel">{{$t('Cancel')}}</button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import * as echarts from 'echarts'
  import auth from '../../auth/auth'
  import format from '@/lib/format'
  import B64 from '../../auth/base64'
  import dataTool from '../../auth/dataTool'
  import {loading} from '../mixins/loading'

  /*
  Notes:
  2019-8-5
  value1 : 结束时间控件的变量。Date对象。
  value2 : 起始时间控件的变量。
  startDate : 日期控件的显示变量, String 对象。
  * */
  export default{
    mixins: [loading],
    data() {
      return {
        TaData1:[],TaData2:[],TaData3:[],xDate:[],xDate2:[],sgMax:20,value2:'',value1:'',dayNum:0,dayNum2:0,isMg:'',ts:[],interval:'',
        chartWidth: '', timer: false,typeChooseVisible:false,isC:false, flag:0,count:0, sta:'',end:'',Average:[],days:'',isSw:false,
        chart4_1: null,chart4_2: null,chart4_3: null,chart4_4: null,weekModeSp:[],weekM1:false,weekM2:false,isDe:false,isIt:false,isPo:false,isDu:false,
        startDate:'',  timeRange:'',defaultDate:'',whichDay:'Everyday', weekmode:'yyyyyyy',isEn:false,
        uid:0,st:0,et:0,basalMax:25,bgMax:10,dialogSize:'small',isFr:false,isCz:false,timeRangeSelect:1,timeIntervalSelect:1,
        intervalOption:[[1, this.$t('Day')]], /* , [2, '周'], [3, '月'] */
        chartNameList: ['chart4_1','chart4_2','chart4_3','chart4_4'],

        intervalOptionSave:[],     // 点取消时恢复上一次的设置
        timeIntervalSelectSave:1,
        timeRangeSelectSave:1,

        startDateEditable:false,
        startDateDisable:true,
        date:[true,true,true,true,true,true,true],
        pickerOptions:{
          disabledDate(time){
            let t1=time.getTime();
            let d2=new Date();
            let t2=d2.getTime();
            //return (t1>t2 || (d2.getYear()-time.getYear())>2 );
            return (t1>t2 || t1<(t2-730*86400*1000));
          }
        },
        textStyle: {
          color: '#282828',
          fontWeight: 'normal',
          fontSize: '14',
          fontFamily: 'SFUIText-Regular'
        },
        titlePadding: [0, 0, 8, 33],
        grid: {x: '3%', y: '15%', width: '94.5%', height: '70%'},
        yAxisLabel: {interval: 0, margin: 5, textStyle: {color: '#282828', baseline: 'middle'}, showMinLabel: false},
        xLabel:['18-07-2017','19-07-2017','20-07-2017','21-07-2017','22-07-2017','23-07-2017','24-07-2017','25-07-2017',
                '26-07-2017','27-07-2017','28-07-2017','29-07-2017','30-07-2017','31-07-2017'],
        // report use
        //xDate2:[],
        glucose:[],
        glucoseDefault: [
          {
            "bg_avg": '--',
            "bg_hypo_num": '--',    // 严重低个数
            "bg_lp":'--',       // 偏低百分比
            "bg_tp":'--',       // 正常百分比
            "bg_up":'--',       // 偏高百分比
            "bg_low_num": '--',
            "bg_num": '--',
            "bg_sd": '--',
            "sg_aucl": "--",
            "sg_aucu": "--",
            "sg_avg": "--",
            "sg_cv": "--",
            "sg_iqr": "--",
            "sg_lp": "--",
            "sg_lpr": "--",
            "sg_max": "--",
            "sg_median": "--",
            "sg_min": "--",
            "sg_mpr": "--",
            "sg_nl": "--",
            "sg_nu": "--",
            "sg_q1": "--",
            "sg_q3": "--",
            "sg_sd": "--",
            "sg_sdr": "--",
            "sg_se": "--",
            "sg_spr": "--",
            "sg_tp": "--",
            "sg_up": "--",
          },
          {
            "bg_avg": '--',
            "bg_hypo_num": '--',    // 严重低个数
            "bg_lp":'--',       // 偏低百分比
            "bg_tp":'--',       // 正常百分比
            "bg_up":'--',       // 偏高百分比
            "bg_low_num": '--',
            "bg_num": '--',
            "bg_sd": '--',
            "sg_aucl": "--",
            "sg_aucu": "--",
            "sg_avg": "--",
            "sg_cv": "--",
            "sg_iqr": "--",
            "sg_lp": "--",
            "sg_lpr": "--",
            "sg_max": "--",
            "sg_median": "--",
            "sg_min": "--",
            "sg_mpr": "--",
            "sg_nl": "--",
            "sg_nu": "--",
            "sg_q1": "--",
            "sg_q3": "--",
            "sg_sd": "--",
            "sg_sdr": "--",
            "sg_se": "--",
            "sg_spr": "--",
            "sg_tp": "--",
            "sg_up": "--",
          },
          {
            "bg_avg": '--',
            "bg_hypo_num": '--',    // 严重低个数
            "bg_lp":'--',       // 偏低百分比
            "bg_tp":'--',       // 正常百分比
            "bg_up":'--',       // 偏高百分比
            "bg_low_num": '--',
            "bg_num": '--',
            "bg_sd": '--',
            "sg_aucl": "--",
            "sg_aucu": "--",
            "sg_avg": "--",
            "sg_cv": "--",
            "sg_iqr": "--",
            "sg_lp": "--",
            "sg_lpr": "--",
            "sg_max": "--",
            "sg_median": "--",
            "sg_min": "--",
            "sg_mpr": "--",
            "sg_nl": "--",
            "sg_nu": "--",
            "sg_q1": "--",
            "sg_q3": "--",
            "sg_sd": "--",
            "sg_sdr": "--",
            "sg_se": "--",
            "sg_spr": "--",
            "sg_tp": "--",
            "sg_up": "--",
          },
          {
            "bg_avg": '--',
            "bg_hypo_num": '--',    // 严重低个数
            "bg_lp":'--',       // 偏低百分比
            "bg_tp":'--',       // 正常百分比
            "bg_up":'--',       // 偏高百分比
            "bg_low_num": '--',
            "bg_num": '--',
            "bg_sd": '--',
            "sg_aucl": "--",
            "sg_aucu": "--",
            "sg_avg": "--",
            "sg_cv": "--",
            "sg_iqr": "--",
            "sg_lp": "--",
            "sg_lpr": "--",
            "sg_max": "--",
            "sg_median": "--",
            "sg_min": "--",
            "sg_mpr": "--",
            "sg_nl": "--",
            "sg_nu": "--",
            "sg_q1": "--",
            "sg_q3": "--",
            "sg_sd": "--",
            "sg_sdr": "--",
            "sg_se": "--",
            "sg_spr": "--",
            "sg_tp": "--",
            "sg_up": "--",
          },
          {
            "bg_avg": '--',
            "bg_hypo_num": '--',    // 严重低个数
            "bg_lp":'--',       // 偏低百分比
            "bg_tp":'--',       // 正常百分比
            "bg_up":'--',       // 偏高百分比
            "bg_low_num": '--',
            "bg_num": '--',
            "bg_sd": '--',
            "sg_aucl": "--",
            "sg_aucu": "--",
            "sg_avg": "--",
            "sg_cv": "--",
            "sg_iqr": "--",
            "sg_lp": "--",
            "sg_lpr": "--",
            "sg_max": "--",
            "sg_median": "--",
            "sg_min": "--",
            "sg_mpr": "--",
            "sg_nl": "--",
            "sg_nu": "--",
            "sg_q1": "--",
            "sg_q3": "--",
            "sg_sd": "--",
            "sg_sdr": "--",
            "sg_se": "--",
            "sg_spr": "--",
            "sg_tp": "--",
            "sg_up": "--",
          },
          {
            "bg_avg": '--',
            "bg_hypo_num": '--',    // 严重低个数
            "bg_lp":'--',       // 偏低百分比
            "bg_tp":'--',       // 正常百分比
            "bg_up":'--',       // 偏高百分比
            "bg_low_num": '--',
            "bg_num": '--',
            "bg_sd": '--',
            "sg_aucl": "--",
            "sg_aucu": "--",
            "sg_avg": "--",
            "sg_cv": "--",
            "sg_iqr": "--",
            "sg_lp": "--",
            "sg_lpr": "--",
            "sg_max": "--",
            "sg_median": "--",
            "sg_min": "--",
            "sg_mpr": "--",
            "sg_nl": "--",
            "sg_nu": "--",
            "sg_q1": "--",
            "sg_q3": "--",
            "sg_sd": "--",
            "sg_sdr": "--",
            "sg_se": "--",
            "sg_spr": "--",
            "sg_tp": "--",
            "sg_up": "--",
          },
          {
            "bg_avg": '--',
            "bg_hypo_num": '--',    // 严重低个数
            "bg_lp":'--',       // 偏低百分比
            "bg_tp":'--',       // 正常百分比
            "bg_up":'--',       // 偏高百分比
            "bg_low_num": '--',
            "bg_num": '--',
            "bg_sd": '--',
            "sg_aucl": "--",
            "sg_aucu": "--",
            "sg_avg": "--",
            "sg_cv": "--",
            "sg_iqr": "--",
            "sg_lp": "--",
            "sg_lpr": "--",
            "sg_max": "--",
            "sg_median": "--",
            "sg_min": "--",
            "sg_mpr": "--",
            "sg_nl": "--",
            "sg_nu": "--",
            "sg_q1": "--",
            "sg_q3": "--",
            "sg_sd": "--",
            "sg_sdr": "--",
            "sg_se": "--",
            "sg_spr": "--",
            "sg_tp": "--",
            "sg_up": "--",
          },
          {
            "bg_avg": '--',
            "bg_hypo_num": '--',    // 严重低个数
            "bg_lp":'--',       // 偏低百分比
            "bg_tp":'--',       // 正常百分比
            "bg_up":'--',       // 偏高百分比
            "bg_low_num": '--',
            "bg_num": '--',
            "bg_sd": '--',
            "sg_aucl": "--",
            "sg_aucu": "--",
            "sg_avg": "--",
            "sg_cv": "--",
            "sg_iqr": "--",
            "sg_lp": "--",
            "sg_lpr": "--",
            "sg_max": "--",
            "sg_median": "--",
            "sg_min": "--",
            "sg_mpr": "--",
            "sg_nl": "--",
            "sg_nu": "--",
            "sg_q1": "--",
            "sg_q3": "--",
            "sg_sd": "--",
            "sg_sdr": "--",
            "sg_se": "--",
            "sg_spr": "--",
            "sg_tp": "--",
            "sg_up": "--",
          },
          {
            "bg_avg": '--',
            "bg_hypo_num": '--',    // 严重低个数
            "bg_lp":'--',       // 偏低百分比
            "bg_tp":'--',       // 正常百分比
            "bg_up":'--',       // 偏高百分比
            "bg_low_num": '--',
            "bg_num": '--',
            "bg_sd": '--',
            "sg_aucl": "--",
            "sg_aucu": "--",
            "sg_avg": "--",
            "sg_cv": "--",
            "sg_iqr": "--",
            "sg_lp": "--",
            "sg_lpr": "--",
            "sg_max": "--",
            "sg_median": "--",
            "sg_min": "--",
            "sg_mpr": "--",
            "sg_nl": "--",
            "sg_nu": "--",
            "sg_q1": "--",
            "sg_q3": "--",
            "sg_sd": "--",
            "sg_sdr": "--",
            "sg_se": "--",
            "sg_spr": "--",
            "sg_tp": "--",
            "sg_up": "--",
          },
          {
            "bg_avg": '--',
            "bg_hypo_num": '--',    // 严重低个数
            "bg_lp":'--',       // 偏低百分比
            "bg_tp":'--',       // 正常百分比
            "bg_up":'--',       // 偏高百分比
            "bg_low_num": '--',
            "bg_num": '--',
            "bg_sd": '--',
            "sg_aucl": "--",
            "sg_aucu": "--",
            "sg_avg": "--",
            "sg_cv": "--",
            "sg_iqr": "--",
            "sg_lp": "--",
            "sg_lpr": "--",
            "sg_max": "--",
            "sg_median": "--",
            "sg_min": "--",
            "sg_mpr": "--",
            "sg_nl": "--",
            "sg_nu": "--",
            "sg_q1": "--",
            "sg_q3": "--",
            "sg_sd": "--",
            "sg_sdr": "--",
            "sg_se": "--",
            "sg_spr": "--",
            "sg_tp": "--",
            "sg_up": "--",
          },
          {
            "bg_avg": '--',
            "bg_hypo_num": '--',    // 严重低个数
            "bg_lp":'--',       // 偏低百分比
            "bg_tp":'--',       // 正常百分比
            "bg_up":'--',       // 偏高百分比
            "bg_low_num": '--',
            "bg_num": '--',
            "bg_sd": '--',
            "sg_aucl": "--",
            "sg_aucu": "--",
            "sg_avg": "--",
            "sg_cv": "--",
            "sg_iqr": "--",
            "sg_lp": "--",
            "sg_lpr": "--",
            "sg_max": "--",
            "sg_median": "--",
            "sg_min": "--",
            "sg_mpr": "--",
            "sg_nl": "--",
            "sg_nu": "--",
            "sg_q1": "--",
            "sg_q3": "--",
            "sg_sd": "--",
            "sg_sdr": "--",
            "sg_se": "--",
            "sg_spr": "--",
            "sg_tp": "--",
            "sg_up": "--",
          },
          {
            "bg_avg": '--',
            "bg_hypo_num": '--',    // 严重低个数
            "bg_lp":'--',       // 偏低百分比
            "bg_tp":'--',       // 正常百分比
            "bg_up":'--',       // 偏高百分比
            "bg_low_num": '--',
            "bg_num": '--',
            "bg_sd": '--',
            "sg_aucl": "--",
            "sg_aucu": "--",
            "sg_avg": "--",
            "sg_cv": "--",
            "sg_iqr": "--",
            "sg_lp": "--",
            "sg_lpr": "--",
            "sg_max": "--",
            "sg_median": "--",
            "sg_min": "--",
            "sg_mpr": "--",
            "sg_nl": "--",
            "sg_nu": "--",
            "sg_q1": "--",
            "sg_q3": "--",
            "sg_sd": "--",
            "sg_sdr": "--",
            "sg_se": "--",
            "sg_spr": "--",
            "sg_tp": "--",
            "sg_up": "--",
          },
          {
            "bg_avg": '--',
            "bg_hypo_num": '--',    // 严重低个数
            "bg_lp":'--',       // 偏低百分比
            "bg_tp":'--',       // 正常百分比
            "bg_up":'--',       // 偏高百分比
            "bg_low_num": '--',
            "bg_num": '--',
            "bg_sd": '--',
            "sg_aucl": "--",
            "sg_aucu": "--",
            "sg_avg": "--",
            "sg_cv": "--",
            "sg_iqr": "--",
            "sg_lp": "--",
            "sg_lpr": "--",
            "sg_max": "--",
            "sg_median": "--",
            "sg_min": "--",
            "sg_mpr": "--",
            "sg_nl": "--",
            "sg_nu": "--",
            "sg_q1": "--",
            "sg_q3": "--",
            "sg_sd": "--",
            "sg_sdr": "--",
            "sg_se": "--",
            "sg_spr": "--",
            "sg_tp": "--",
            "sg_up": "--",
          },
          {
            "bg_avg": '--',
            "bg_hypo_num": '--',    // 严重低个数
            "bg_lp":'--',       // 偏低百分比
            "bg_tp":'--',       // 正常百分比
            "bg_up":'--',       // 偏高百分比
            "bg_low_num": '--',
            "bg_num": '--',
            "bg_sd": '--',
            "sg_aucl": "--",
            "sg_aucu": "--",
            "sg_avg": "--",
            "sg_cv": "--",
            "sg_iqr": "--",
            "sg_lp": "--",
            "sg_lpr": "--",
            "sg_max": "--",
            "sg_median": "--",
            "sg_min": "--",
            "sg_mpr": "--",
            "sg_nl": "--",
            "sg_nu": "--",
            "sg_q1": "--",
            "sg_q3": "--",
            "sg_sd": "--",
            "sg_sdr": "--",
            "sg_se": "--",
            "sg_spr": "--",
            "sg_tp": "--",
            "sg_up": "--",
          },
          {
            "bg_avg": '--',
            "bg_hypo_num": '--',    // 严重低个数
            "bg_lp":'--',       // 偏低百分比
            "bg_tp":'--',       // 正常百分比
            "bg_up":'--',       // 偏高百分比
            "bg_low_num": '--',
            "bg_num": '--',
            "bg_sd": '--',
            "sg_aucl": "--",
            "sg_aucu": "--",
            "sg_avg": "--",
            "sg_cv": "--",
            "sg_iqr": "--",
            "sg_lp": "--",
            "sg_lpr": "--",
            "sg_max": "--",
            "sg_median": "--",
            "sg_min": "--",
            "sg_mpr": "--",
            "sg_nl": "--",
            "sg_nu": "--",
            "sg_q1": "--",
            "sg_q3": "--",
            "sg_sd": "--",
            "sg_sdr": "--",
            "sg_se": "--",
            "sg_spr": "--",
            "sg_tp": "--",
            "sg_up": "--",
          },
          // 2019.9.27添加到30个， 在加16个
          {
            "bg_avg": '--',"bg_hypo_num": '--',"bg_lp":'--',"bg_tp":'--',"bg_up":'--',"bg_low_num": '--',
            "bg_num": '--',"bg_sd": '--',"sg_aucl": "--","sg_aucu": "--","sg_avg": "--","sg_cv": "--","sg_iqr": "--","sg_lp": "--",
            "sg_lpr": "--","sg_max": "--","sg_median": "--","sg_min": "--","sg_mpr": "--","sg_nl": "--","sg_nu": "--","sg_q1": "--",
            "sg_q3": "--","sg_sd": "--","sg_sdr": "--","sg_se": "--","sg_spr": "--","sg_tp": "--","sg_up": "--",
          },
          {
            "bg_avg": '--',"bg_hypo_num": '--',"bg_lp":'--',"bg_tp":'--',"bg_up":'--',"bg_low_num": '--',
            "bg_num": '--',"bg_sd": '--',"sg_aucl": "--","sg_aucu": "--","sg_avg": "--","sg_cv": "--","sg_iqr": "--","sg_lp": "--",
            "sg_lpr": "--","sg_max": "--","sg_median": "--","sg_min": "--","sg_mpr": "--","sg_nl": "--","sg_nu": "--","sg_q1": "--",
            "sg_q3": "--","sg_sd": "--","sg_sdr": "--","sg_se": "--","sg_spr": "--","sg_tp": "--","sg_up": "--",
          },
          {
            "bg_avg": '--',"bg_hypo_num": '--',"bg_lp":'--',"bg_tp":'--',"bg_up":'--',"bg_low_num": '--',
            "bg_num": '--',"bg_sd": '--',"sg_aucl": "--","sg_aucu": "--","sg_avg": "--","sg_cv": "--","sg_iqr": "--","sg_lp": "--",
            "sg_lpr": "--","sg_max": "--","sg_median": "--","sg_min": "--","sg_mpr": "--","sg_nl": "--","sg_nu": "--","sg_q1": "--",
            "sg_q3": "--","sg_sd": "--","sg_sdr": "--","sg_se": "--","sg_spr": "--","sg_tp": "--","sg_up": "--",
          },
          {
            "bg_avg": '--',"bg_hypo_num": '--',"bg_lp":'--',"bg_tp":'--',"bg_up":'--',"bg_low_num": '--',
            "bg_num": '--',"bg_sd": '--',"sg_aucl": "--","sg_aucu": "--","sg_avg": "--","sg_cv": "--","sg_iqr": "--","sg_lp": "--",
            "sg_lpr": "--","sg_max": "--","sg_median": "--","sg_min": "--","sg_mpr": "--","sg_nl": "--","sg_nu": "--","sg_q1": "--",
            "sg_q3": "--","sg_sd": "--","sg_sdr": "--","sg_se": "--","sg_spr": "--","sg_tp": "--","sg_up": "--",
          },
          {
            "bg_avg": '--',"bg_hypo_num": '--',"bg_lp":'--',"bg_tp":'--',"bg_up":'--',"bg_low_num": '--',
            "bg_num": '--',"bg_sd": '--',"sg_aucl": "--","sg_aucu": "--","sg_avg": "--","sg_cv": "--","sg_iqr": "--","sg_lp": "--",
            "sg_lpr": "--","sg_max": "--","sg_median": "--","sg_min": "--","sg_mpr": "--","sg_nl": "--","sg_nu": "--","sg_q1": "--",
            "sg_q3": "--","sg_sd": "--","sg_sdr": "--","sg_se": "--","sg_spr": "--","sg_tp": "--","sg_up": "--",
          },
          {
            "bg_avg": '--',"bg_hypo_num": '--',"bg_lp":'--',"bg_tp":'--',"bg_up":'--',"bg_low_num": '--',
            "bg_num": '--',"bg_sd": '--',"sg_aucl": "--","sg_aucu": "--","sg_avg": "--","sg_cv": "--","sg_iqr": "--","sg_lp": "--",
            "sg_lpr": "--","sg_max": "--","sg_median": "--","sg_min": "--","sg_mpr": "--","sg_nl": "--","sg_nu": "--","sg_q1": "--",
            "sg_q3": "--","sg_sd": "--","sg_sdr": "--","sg_se": "--","sg_spr": "--","sg_tp": "--","sg_up": "--",
          },
          {
            "bg_avg": '--',"bg_hypo_num": '--',"bg_lp":'--',"bg_tp":'--',"bg_up":'--',"bg_low_num": '--',
            "bg_num": '--',"bg_sd": '--',"sg_aucl": "--","sg_aucu": "--","sg_avg": "--","sg_cv": "--","sg_iqr": "--","sg_lp": "--",
            "sg_lpr": "--","sg_max": "--","sg_median": "--","sg_min": "--","sg_mpr": "--","sg_nl": "--","sg_nu": "--","sg_q1": "--",
            "sg_q3": "--","sg_sd": "--","sg_sdr": "--","sg_se": "--","sg_spr": "--","sg_tp": "--","sg_up": "--",
          },
          {
            "bg_avg": '--',"bg_hypo_num": '--',"bg_lp":'--',"bg_tp":'--',"bg_up":'--',"bg_low_num": '--',
            "bg_num": '--',"bg_sd": '--',"sg_aucl": "--","sg_aucu": "--","sg_avg": "--","sg_cv": "--","sg_iqr": "--","sg_lp": "--",
            "sg_lpr": "--","sg_max": "--","sg_median": "--","sg_min": "--","sg_mpr": "--","sg_nl": "--","sg_nu": "--","sg_q1": "--",
            "sg_q3": "--","sg_sd": "--","sg_sdr": "--","sg_se": "--","sg_spr": "--","sg_tp": "--","sg_up": "--",
          },
          {
            "bg_avg": '--',"bg_hypo_num": '--',"bg_lp":'--',"bg_tp":'--',"bg_up":'--',"bg_low_num": '--',
            "bg_num": '--',"bg_sd": '--',"sg_aucl": "--","sg_aucu": "--","sg_avg": "--","sg_cv": "--","sg_iqr": "--","sg_lp": "--",
            "sg_lpr": "--","sg_max": "--","sg_median": "--","sg_min": "--","sg_mpr": "--","sg_nl": "--","sg_nu": "--","sg_q1": "--",
            "sg_q3": "--","sg_sd": "--","sg_sdr": "--","sg_se": "--","sg_spr": "--","sg_tp": "--","sg_up": "--",
          },
          {
            "bg_avg": '--',"bg_hypo_num": '--',"bg_lp":'--',"bg_tp":'--',"bg_up":'--',"bg_low_num": '--',
            "bg_num": '--',"bg_sd": '--',"sg_aucl": "--","sg_aucu": "--","sg_avg": "--","sg_cv": "--","sg_iqr": "--","sg_lp": "--",
            "sg_lpr": "--","sg_max": "--","sg_median": "--","sg_min": "--","sg_mpr": "--","sg_nl": "--","sg_nu": "--","sg_q1": "--",
            "sg_q3": "--","sg_sd": "--","sg_sdr": "--","sg_se": "--","sg_spr": "--","sg_tp": "--","sg_up": "--",
          },
          {
            "bg_avg": '--',"bg_hypo_num": '--',"bg_lp":'--',"bg_tp":'--',"bg_up":'--',"bg_low_num": '--',
            "bg_num": '--',"bg_sd": '--',"sg_aucl": "--","sg_aucu": "--","sg_avg": "--","sg_cv": "--","sg_iqr": "--","sg_lp": "--",
            "sg_lpr": "--","sg_max": "--","sg_median": "--","sg_min": "--","sg_mpr": "--","sg_nl": "--","sg_nu": "--","sg_q1": "--",
            "sg_q3": "--","sg_sd": "--","sg_sdr": "--","sg_se": "--","sg_spr": "--","sg_tp": "--","sg_up": "--",
          },
          {
            "bg_avg": '--',"bg_hypo_num": '--',"bg_lp":'--',"bg_tp":'--',"bg_up":'--',"bg_low_num": '--',
            "bg_num": '--',"bg_sd": '--',"sg_aucl": "--","sg_aucu": "--","sg_avg": "--","sg_cv": "--","sg_iqr": "--","sg_lp": "--",
            "sg_lpr": "--","sg_max": "--","sg_median": "--","sg_min": "--","sg_mpr": "--","sg_nl": "--","sg_nu": "--","sg_q1": "--",
            "sg_q3": "--","sg_sd": "--","sg_sdr": "--","sg_se": "--","sg_spr": "--","sg_tp": "--","sg_up": "--",
          },
          {
            "bg_avg": '--',"bg_hypo_num": '--',"bg_lp":'--',"bg_tp":'--',"bg_up":'--',"bg_low_num": '--',
            "bg_num": '--',"bg_sd": '--',"sg_aucl": "--","sg_aucu": "--","sg_avg": "--","sg_cv": "--","sg_iqr": "--","sg_lp": "--",
            "sg_lpr": "--","sg_max": "--","sg_median": "--","sg_min": "--","sg_mpr": "--","sg_nl": "--","sg_nu": "--","sg_q1": "--",
            "sg_q3": "--","sg_sd": "--","sg_sdr": "--","sg_se": "--","sg_spr": "--","sg_tp": "--","sg_up": "--",
          },
          {
            "bg_avg": '--',"bg_hypo_num": '--',"bg_lp":'--',"bg_tp":'--',"bg_up":'--',"bg_low_num": '--',
            "bg_num": '--',"bg_sd": '--',"sg_aucl": "--","sg_aucu": "--","sg_avg": "--","sg_cv": "--","sg_iqr": "--","sg_lp": "--",
            "sg_lpr": "--","sg_max": "--","sg_median": "--","sg_min": "--","sg_mpr": "--","sg_nl": "--","sg_nu": "--","sg_q1": "--",
            "sg_q3": "--","sg_sd": "--","sg_sdr": "--","sg_se": "--","sg_spr": "--","sg_tp": "--","sg_up": "--",
          },
          {
            "bg_avg": '--',"bg_hypo_num": '--',"bg_lp":'--',"bg_tp":'--',"bg_up":'--',"bg_low_num": '--',
            "bg_num": '--',"bg_sd": '--',"sg_aucl": "--","sg_aucu": "--","sg_avg": "--","sg_cv": "--","sg_iqr": "--","sg_lp": "--",
            "sg_lpr": "--","sg_max": "--","sg_median": "--","sg_min": "--","sg_mpr": "--","sg_nl": "--","sg_nu": "--","sg_q1": "--",
            "sg_q3": "--","sg_sd": "--","sg_sdr": "--","sg_se": "--","sg_spr": "--","sg_tp": "--","sg_up": "--",
          },
          {
            "bg_avg": '--',"bg_hypo_num": '--',"bg_lp":'--',"bg_tp":'--',"bg_up":'--',"bg_low_num": '--',
            "bg_num": '--',"bg_sd": '--',"sg_aucl": "--","sg_aucu": "--","sg_avg": "--","sg_cv": "--","sg_iqr": "--","sg_lp": "--",
            "sg_lpr": "--","sg_max": "--","sg_median": "--","sg_min": "--","sg_mpr": "--","sg_nl": "--","sg_nu": "--","sg_q1": "--",
            "sg_q3": "--","sg_sd": "--","sg_sdr": "--","sg_se": "--","sg_spr": "--","sg_tp": "--","sg_up": "--",
          },

        ],
        event:[],
        eventDefault:[
          {
            "carb_gram": '--',
            "carb_num": '--',
            "exer_num": '--',
            "exer_time": '--',
            "ins_basal": '--',
            "ins_bolus": '--',
            "ins_bolus_avg": "--",
            "ins_bolus_n": '--',
            "ins_bolus_p": "--",
            "ins_total": '--',
            "other": "--",
          },
          {
            "carb_gram": '--',
            "carb_num": '--',
            "exer_num": '--',
            "exer_time": '--',
            "ins_basal": '--',
            "ins_bolus": '--',
            "ins_bolus_avg": "--",
            "ins_bolus_n": '--',
            "ins_bolus_p": "--",
            "ins_total": '--',
            "other": "--",
          },
          {
            "carb_gram": '--',
            "carb_num": '--',
            "exer_num": '--',
            "exer_time": '--',
            "ins_basal": '--',
            "ins_bolus": '--',
            "ins_bolus_avg": "--",
            "ins_bolus_n": '--',
            "ins_bolus_p": "--",
            "ins_total": '--',
            "other": "--",
          },
          {
            "carb_gram": '--',
            "carb_num": '--',
            "exer_num": '--',
            "exer_time": '--',
            "ins_basal": '--',
            "ins_bolus": '--',
            "ins_bolus_avg": "--",
            "ins_bolus_n": '--',
            "ins_bolus_p": "--",
            "ins_total": '--',
            "other": "--",
          },
          {
            "carb_gram": '--',
            "carb_num": '--',
            "exer_num": '--',
            "exer_time": '--',
            "ins_basal": '--',
            "ins_bolus": '--',
            "ins_bolus_avg": "--",
            "ins_bolus_n": '--',
            "ins_bolus_p": "--",
            "ins_total": '--',
            "other": "--",
          },
          {
            "carb_gram": '--',
            "carb_num": '--',
            "exer_num": '--',
            "exer_time": '--',
            "ins_basal": '--',
            "ins_bolus": '--',
            "ins_bolus_avg": "--",
            "ins_bolus_n": '--',
            "ins_bolus_p": "--",
            "ins_total": '--',
            "other": "--",
          },
          {
            "carb_gram": '--',
            "carb_num": '--',
            "exer_num": '--',
            "exer_time": '--',
            "ins_basal": '--',
            "ins_bolus": '--',
            "ins_bolus_avg": "--",
            "ins_bolus_n": '--',
            "ins_bolus_p": "--",
            "ins_total": '--',
            "other": "--",
          },
          {
            "carb_gram": '--',
            "carb_num": '--',
            "exer_num": '--',
            "exer_time": '--',
            "ins_basal": '--',
            "ins_bolus": '--',
            "ins_bolus_avg": "--",
            "ins_bolus_n": '--',
            "ins_bolus_p": "--",
            "ins_total": '--',
            "other": "--",
          },
          {
            "carb_gram": '--',
            "carb_num": '--',
            "exer_num": '--',
            "exer_time": '--',
            "ins_basal": '--',
            "ins_bolus": '--',
            "ins_bolus_avg": "--",
            "ins_bolus_n": '--',
            "ins_bolus_p": "--",
            "ins_total": '--',
            "other": "--",
          },
          {
            "carb_gram": '--',
            "carb_num": '--',
            "exer_num": '--',
            "exer_time": '--',
            "ins_basal": '--',
            "ins_bolus": '--',
            "ins_bolus_avg": "--",
            "ins_bolus_n": '--',
            "ins_bolus_p": "--",
            "ins_total": '--',
            "other": "--",
          },
          {
            "carb_gram": '--',
            "carb_num": '--',
            "exer_num": '--',
            "exer_time": '--',
            "ins_basal": '--',
            "ins_bolus": '--',
            "ins_bolus_avg": "--",
            "ins_bolus_n": '--',
            "ins_bolus_p": "--",
            "ins_total": '--',
            "other": "--",
          },
          {
            "carb_gram": '--',
            "carb_num": '--',
            "exer_num": '--',
            "exer_time": '--',
            "ins_basal": '--',
            "ins_bolus": '--',
            "ins_bolus_avg": "--",
            "ins_bolus_n": '--',
            "ins_bolus_p": "--",
            "ins_total": '--',
            "other": "--",
          },
          {
            "carb_gram": '--',
            "carb_num": '--',
            "exer_num": '--',
            "exer_time": '--',
            "ins_basal": '--',
            "ins_bolus": '--',
            "ins_bolus_avg": "--",
            "ins_bolus_n": '--',
            "ins_bolus_p": "--",
            "ins_total": '--',
            "other": "--",
          },
          {
            "carb_gram": '--',
            "carb_num": '--',
            "exer_num": '--',
            "exer_time": '--',
            "ins_basal": '--',
            "ins_bolus": '--',
            "ins_bolus_avg": "--",
            "ins_bolus_n": '--',
            "ins_bolus_p": "--",
            "ins_total": '--',
            "other": "--",
          },
          {
            "carb_gram": '--',
            "carb_num": '--',
            "exer_num": '--',
            "exer_time": '--',
            "ins_basal": '--',
            "ins_bolus": '--',
            "ins_bolus_avg": "--",
            "ins_bolus_n": '--',
            "ins_bolus_p": "--",
            "ins_total": '--',
            "other": "--",
          },
          // 2019.9.27再加16个
          {
            "carb_gram": '--',"carb_num": '--',"exer_num": '--',"exer_time": '--',
            "ins_basal": '--',"ins_bolus": '--',"ins_bolus_avg": "--","ins_bolus_n": '--',
            "ins_bolus_p": "--","ins_total": '--',"other": "--",
          },
          {
            "carb_gram": '--',"carb_num": '--',"exer_num": '--',"exer_time": '--',
            "ins_basal": '--',"ins_bolus": '--',"ins_bolus_avg": "--","ins_bolus_n": '--',
            "ins_bolus_p": "--","ins_total": '--',"other": "--",
          },
          {
            "carb_gram": '--',"carb_num": '--',"exer_num": '--',"exer_time": '--',
            "ins_basal": '--',"ins_bolus": '--',"ins_bolus_avg": "--","ins_bolus_n": '--',
            "ins_bolus_p": "--","ins_total": '--',"other": "--",
          },
          {
            "carb_gram": '--',"carb_num": '--',"exer_num": '--',"exer_time": '--',
            "ins_basal": '--',"ins_bolus": '--',"ins_bolus_avg": "--","ins_bolus_n": '--',
            "ins_bolus_p": "--","ins_total": '--',"other": "--",
          },
          {
            "carb_gram": '--',"carb_num": '--',"exer_num": '--',"exer_time": '--',
            "ins_basal": '--',"ins_bolus": '--',"ins_bolus_avg": "--","ins_bolus_n": '--',
            "ins_bolus_p": "--","ins_total": '--',"other": "--",
          },
          {
            "carb_gram": '--',"carb_num": '--',"exer_num": '--',"exer_time": '--',
            "ins_basal": '--',"ins_bolus": '--',"ins_bolus_avg": "--","ins_bolus_n": '--',
            "ins_bolus_p": "--","ins_total": '--',"other": "--",
          },
          {
            "carb_gram": '--',"carb_num": '--',"exer_num": '--',"exer_time": '--',
            "ins_basal": '--',"ins_bolus": '--',"ins_bolus_avg": "--","ins_bolus_n": '--',
            "ins_bolus_p": "--","ins_total": '--',"other": "--",
          },
          {
            "carb_gram": '--',"carb_num": '--',"exer_num": '--',"exer_time": '--',
            "ins_basal": '--',"ins_bolus": '--',"ins_bolus_avg": "--","ins_bolus_n": '--',
            "ins_bolus_p": "--","ins_total": '--',"other": "--",
          },
          {
            "carb_gram": '--',"carb_num": '--',"exer_num": '--',"exer_time": '--',
            "ins_basal": '--',"ins_bolus": '--',"ins_bolus_avg": "--","ins_bolus_n": '--',
            "ins_bolus_p": "--","ins_total": '--',"other": "--",
          },
          {
            "carb_gram": '--',"carb_num": '--',"exer_num": '--',"exer_time": '--',
            "ins_basal": '--',"ins_bolus": '--',"ins_bolus_avg": "--","ins_bolus_n": '--',
            "ins_bolus_p": "--","ins_total": '--',"other": "--",
          },
          {
            "carb_gram": '--',"carb_num": '--',"exer_num": '--',"exer_time": '--',
            "ins_basal": '--',"ins_bolus": '--',"ins_bolus_avg": "--","ins_bolus_n": '--',
            "ins_bolus_p": "--","ins_total": '--',"other": "--",
          },
          {
            "carb_gram": '--',"carb_num": '--',"exer_num": '--',"exer_time": '--',
            "ins_basal": '--',"ins_bolus": '--',"ins_bolus_avg": "--","ins_bolus_n": '--',
            "ins_bolus_p": "--","ins_total": '--',"other": "--",
          },
          {
            "carb_gram": '--',"carb_num": '--',"exer_num": '--',"exer_time": '--',
            "ins_basal": '--',"ins_bolus": '--',"ins_bolus_avg": "--","ins_bolus_n": '--',
            "ins_bolus_p": "--","ins_total": '--',"other": "--",
          },
          {
            "carb_gram": '--',"carb_num": '--',"exer_num": '--',"exer_time": '--',
            "ins_basal": '--',"ins_bolus": '--',"ins_bolus_avg": "--","ins_bolus_n": '--',
            "ins_bolus_p": "--","ins_total": '--',"other": "--",
          },
          {
            "carb_gram": '--',"carb_num": '--',"exer_num": '--',"exer_time": '--',
            "ins_basal": '--',"ins_bolus": '--',"ins_bolus_avg": "--","ins_bolus_n": '--',
            "ins_bolus_p": "--","ins_total": '--',"other": "--",
          },
          {
            "carb_gram": '--',"carb_num": '--',"exer_num": '--',"exer_time": '--',
            "ins_basal": '--',"ins_bolus": '--',"ins_bolus_avg": "--","ins_bolus_n": '--',
            "ins_bolus_p": "--","ins_total": '--',"other": "--",
          },
        ],
      }
    },
    computed: {
      DataS(){
        return this.$store.state.DataS;
      },
    },
    methods:{
      getData(){
        this.glucose=this.glucoseDefault;
        this.event=this.eventDefault;
        //console.log('xDate2:', this.xDate2, this.glucose, this.dayNum)

        this.ts = this.getTs2(this,this.st,this.et);
        //console.log('xDate2.1:', this.xDate2, this.glucose, this.dayNum)
        let param = {
          ts:this.ts,
          interval:this.interval,
          tz:parseInt(sessionStorage.getItem('tz')),
          weekmode:this.weekmode,
          gu:(this.isMg)?'mg/dL':'mmol/L',
        };

        param = B64.base64encode(JSON.stringify(param));
        auth.getTa(this,this.uid,param);

        /*let that=this;
        auth.getDataMap(this, this.uid, function(res){
          //console.log(res)
          if (0!=res.error) {
            return;
          }
          var end_time=(res.end.cgms > res.end.pump)?res.end.cgms:res.end.pump;
          //console.log(param)
          var ts_size=param.ts.length;
          var time_offset=0;
          if ('d'==that.interval) {
            var cur_end=param.ts[ts_size-1][1];
          } else {
            var day_num=param.ts[ts_size-1].length;
            var cur_end=param.ts[ts_size-1][day_num-1][1];
          }

          console.log(cur_end + ', '+end_time);
          for (var d=0; d<3000;d++) {
            if(cur_end>end_time) {
              cur_end -= 24*3600;
            } else {
              break;
            }
          }
          console.log(d)
          if (d)
            d -= 1;

          if (1) {
            if ('d'==that.interval) {
              for (var i=0; i<ts_size; i++) {
                param.ts[i][0] -= 24*3600*d;
                param.ts[i][1] -= 24*3600*d;
              }
              //
              that.et = param.ts[ts_size-1][0];
              that.st = param.ts[0][0];
            } else {
              for (var i=0; i<ts_size; i++) {
                var day_num=param.ts[i].length;
                for (var j=0;j<day_num;j++) {
                  param.ts[i][j][0] -= 24*3600*d;
                  param.ts[i][j][1] -= 24*3600*d;
                }
              }
              //
              var day_num=param.ts[ts_size-1].length;
              that.et = param.ts[ts_size-1][day_num-1][0];
              that.st = param.ts[0][0][0];
            }



            //that.weekmode = 'yyyyyyy';
            that.timeRange = format.formatterDate2(that.st)+'-'+format.formatterDate2(that.et)+', '+that.$t(that.whichDay);
            that.getTs2(that, that.st, that.et);
            that.startDate = format.formatterDate4(that.st);
            that.defaultDate =format.formatterDate4(that.et) ;

            param = B64.base64encode(JSON.stringify(param));
            auth.getTa(that, that.uid, param);
          }


        })*/
      },
      procTimeRangeSelect(e){
        console.log('procTimeRangeSelect:', this.timeRangeSelect);
        let daySpan=0;
        if (1==this.timeRangeSelect){   // 7天
          this.intervalOption=[[1, this.$t('Day')]];
          this.timeIntervalSelect=1;
          daySpan=7;
        } else if (2==this.timeRangeSelect){  // 14天
          this.intervalOption=[[1, this.$t('Day')], [2, this.$t('Week')]];
          this.timeIntervalSelect=1;
          daySpan=14;
        } else if (3==this.timeRangeSelect || 4==this.timeRangeSelect){  // 30天
          this.intervalOption=[[2, this.$t('Week')], [3, this.$t('Month2')]];
          this.timeIntervalSelect=2;
          daySpan=30;
          if (4==this.timeRangeSelect) {
            daySpan=90;
          }
        }
        //
        console.log('daySpan:', daySpan);
        if (daySpan) {
          let st=this.et-86400*(daySpan-1);   // 不能保存到st，只有点确定按钮的时候才保存。
          this.startDate=format.formatterDate4(st);
          this.value2=new Date(st*1000);
        }
        if (0==this.timeRangeSelect) {
          this.startDateDisable=false;
        } else {
          this.startDateDisable=true;
        }
        console.log('startDateDisable:', this.startDateDisable);
      },
      procTimeIntervalSelect(e){
        console.log('procTimeIntervalSelect:', this.timeIntervalSelect);
      },
      drawChart4_1() {
        let id = 'chart4_1'
        let that = this;
        // 字符串计算
        let textTitle='';
        if (this){
          textTitle=(this.isMg)? this.$t('sensorGlu')+' (mg/dL)':this.$t('sensorGlu')+' (mmol/L)';
        }
        this.chart4_1 = echarts.init(document.getElementById(id));
        this.registLoading(id,this.chart4_1)
        this.chart4_1.setOption({
          title: {
            text: textTitle,
            textStyle: this.textStyle,
            padding: this.titlePadding,
          },
          tooltip:{
            backgroundColor:'#555',
            textStyle:{
              color: '#ffffff',
            },
            formatter:function(params){
              //  console.log(params);
              let index = params.seriesIndex,name = params.name,tip='',value = params.value ,seriesName = params.seriesName;
              let icon  =" <div style='background: #0095ff;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
              if(index===0){
                let tip1 =  seriesName+' '+that.$t('min')+' : '+value[1]+'<br>';
                let tip2 =  seriesName+' '+that.$t('Q11')+' : '+value[2]+'<br>';
                let tip3 =  seriesName+' '+that.$t('med')+' : '+value[3]+'<br>';
                let tip4 =  seriesName+' '+that.$t('Q31')+' : '+value[4]+'<br>';
                let tip5 =  seriesName+' '+that.$t('max')+' : '+value[5]+'<br>';
                tip= icon + name+'<br>'+tip5+tip4+tip3+tip2+tip1;
              }
              if(index===1){
                //let tip1 =  seriesName+' : '+value+'<br>';
                //tip= icon + name+'<br>'+tip1;
              }
              return tip;
            },
          },
          xAxis: [{
            data:this.xDate,
            axisLine: {lineStyle: {color: '#ccc'}},
            splitLine:{show:true,interval:0},
            axisLabel:{margin: 15, interval:0,textStyle: {color: '#282828', baseline: 'middle'},
              xx_formatter:function(value, index){
                console.log("value.index:", value, index);
                return '112';
              }
            },

          }],
          yAxis: [{
            type: 'value',
            min:0,max: (this.isMg)? 400:25,
            axisLabel: this.yAxisLabel,
            axisLine: {lineStyle: {color: '#ccc'}},
            boundaryGap: false,
            axisTick: {length: 0},
          }],
          grid: this.grid,
          series: [
            {
              type:'boxplot',
              data:this.TaData3[1],
              hoverAnimation:false,
              boxWidth:['10%','15%'],
              itemStyle: {normal: {borderColor:'#0095ff',},},
            },
            {
              name:this.$t('med'),
              type:'line',
              data:this.TaData3[0],
              itemStyle: {normal: {
                color:'transparent',
                borderColor:'#0095ff',
                borderWidth:1,
              }},
              lineStyle:{normal:{
                color:'#e89b00',
                width:1,
              }},
              symbol:'diamond',
              symbolSize:5,
            },
          ],
        });
        
      },
      drawChart4_2() {
        let id = 'chart4_2'
        this.chart4_2 = echarts.init(document.getElementById(id));
        this.chart4_2.setOption({
          title: {
            text: this.$t('insulin')+' '+this.$t('ins_unit'),
            textStyle: this.textStyle,
            padding: this.titlePadding,
          },
          tooltip:{},
          xAxis: [
            {
              data:this.xDate,
              axisLine: {lineStyle: {color: '#ccc'}},
              splitLine:{show:true,interval:0},
              splitNumber:14,
              axisLabel:{
                margin: 15, interval:0,textStyle: {color: '#282828', baseline: 'middle'} ,
              },
            }],
          yAxis: [
            {
              type: 'value',
              min:0,
              max:this.basalMax,
              axisLabel: this.yAxisLabel,
              axisLine: {lineStyle: {color: '#ccc'}},
              boundaryGap: false,
              axisTick: {length: 0},
            }],
          grid: this.grid,
          legend:{
            itemWidth:11,
            itemHeight:11,
            right:35,
            data:[
              { name:this.$t('basal'),icon:'rect'},
              { name:this.$t('bolus'),icon:'rect'}
            ]
          },
          series: [
            {
              name:this.$t('basal'),
              type:'bar',
              data:this.TaData2[0],
              barWidth:'32%',
              itemStyle: {normal: {color:'#75e28a',}},
            },
            {
              name:this.$t('bolus'),
              type:'bar',
              data:this.TaData2[1],
              barWidth:'32%',
              itemStyle: {normal: {color:'#4e86f4',}},
            },
          ],
        });
      },
      drawChart4_3() {
        let id = 'chart4_3'
        this.chart4_3 = echarts.init(document.getElementById('chart4_3'));
        this.chart4_3.setOption({
          title: {
            text: this.$t('sensorGlu')+' (%)',
            textStyle: this.textStyle,
            padding: this.titlePadding,
          },
          tooltip:{},
          xAxis: [
            {
              data:this.xDate,
              axisLine: {lineStyle: {color: '#ccc'}},
              splitLine:{show:true,interval:0},
              splitNumber:14,
              axisLabel:{
                margin: 15, interval:0,textStyle: {color: '#282828', baseline: 'middle'} ,
              },
            }],
          yAxis: [
            {
              type: 'value',
              min:0,max:100,
              axisLabel: this.yAxisLabel,
              axisLine: {lineStyle: {color: '#ccc'}},
              boundaryGap: false,
              axisTick: {length: 0},
            }],
          grid: this.grid,
          legend:{
            itemWidth:11,
            itemHeight:11,
            right:33,
            data:[
              { name:this.$t('target'),icon:'rect'},
              { name:this.$t('low'),icon:'rect'},
              { name:this.$t('high'),icon:'rect'}
            ]
          },
          series: [
            {
              name:this.$t('target'),
              type:'bar',
              data:this.TaData1[1][0],
              barWidth:'25%',
              itemStyle: {normal: {
                color:'#63d644',
              }},
            },
            {
              name:this.$t('low'),
              type:'bar',
              data:this.TaData1[1][1],
              barWidth:'25%',
              itemStyle: {normal: {
                color:'#ff5c5c',
              }},
            },
            {
              name:this.$t('high'),
              type:'bar',
              data:this.TaData1[1][2],
              barWidth:'25%',
              itemStyle: {normal: {
                color:'#ffd71d',
              }},
            },
          ],
        });
      },
      drawChart4_4() {
        let id = 'chart4_4'
        this.chart4_4 = echarts.init(document.getElementById('chart4_4'));
        this.chart4_4.setOption({
          title: {
            text:this.$t('ofBGtest'),
            textStyle: this.textStyle,
            padding: this.titlePadding,
          },
          tooltip:{},
          xAxis: [
            {
              data:this.xDate,
              axisLine: {lineStyle: {color: '#ccc'}},
              splitLine:{show:true,interval:0},
              splitNumber:14,
              axisLabel:{
                margin: 15, interval:0,textStyle: {color: '#282828', baseline: 'middle'} ,
              },
            }],
          yAxis: [{
            type: 'value',
            min:0,max:this.bgMax,
            axisLabel: this.yAxisLabel,
            axisLine: {lineStyle: {color: '#ccc'}},
            boundaryGap: false,
            axisTick: {length: 0},
          }],
          grid: this.grid,
          legend:{
            itemWidth:11,
            itemHeight:11,
            right:33,
            data:[
              { name:this.$t('target'),icon:'rect'},
              { name:this.$t('low'),icon:'rect'},
              { name:this.$t('high'),icon:'rect'}
            ]
          },
          series: [
            {
              name:this.$t('target'),
              type:'bar',
              data:this.TaData1[0][0],
              barWidth:'25%',
              itemStyle: {normal: {
                color:'#63d644',
              }},
            },
            {
              name:this.$t('low'),
              type:'bar',
              data:this.TaData1[0][1],
              barWidth:'25%',
              itemStyle: {normal: {
                color:'#ff5c5c',
              }},
            },
            {
              name:this.$t('high'),
              type:'bar',
              data:this.TaData1[0][2],
              barWidth:'25%',
              itemStyle: {normal: {
                color:'#ffd71d',
              }},
            },
          ],
        });
      },

      getTaReportInfo(report_data){
        //let data =  res.data.data;
        sessionStorage.setItem('ta_report_data', JSON.stringify(report_data));
        let data=report_data;
        //return;
        //console.log('ta.data:'+JSON.stringify(data));
        data.medical_history = (data.medical_history )?this.$t(data.medical_history):"--";
        this.statics = data;
        this.devices = (data.devices)?data.devices:this.devices;
        this.hb1c = (data.hba1c)?data.hba1c:this.hb1c;
        this.glucose = (data.glucose_stat)?data.glucose_stat:this.glucose;
        this.glucose.map(function (e,i) {
          if(e.bg_up!=='--'){
            e.bg_up = e.bg_up.toFixed(1);
          }
          if(e.bg_tp!=='--'){
            e.bg_tp = e.bg_tp.toFixed(1);
          }
          if(e.bg_lp!=='--'){
            e.bg_lp = e.bg_lp.toFixed(1);
          }
        });
        this.dayNum = this.glucose.length-1;
        this.event = (data.insulin_and_event_stat)?data.insulin_and_event_stat:this.event;
        //let t = (this.interval!=='d')?3000:2000;
        //setTimeout(auth._printPdf(),t);
      },

      drwCharts(){
        this.drawChart4_1();
        this.drawChart4_2();
        //this.drawChart4_3();
        //this.drawChart4_4();
      },
      chartsDispose(){
        if( this.chart4_3){
            this.chart4_1.dispose();
            this.chart4_2.dispose();
            //this.chart4_3.dispose();
            //this.chart4_4.dispose();
        }
      },
      handleResize(){
        let win = window.innerWidth;
        let scale = (win<1500)?0.91:0.62;
        const chartWidth = win * scale * 0.98 * 0.94 + 'px';
        let chart4_1 = document.getElementById('chart4_1');
        let chart4_2 = document.getElementById('chart4_2');
        //let chart4_3 = document.getElementById('chart4_3');
        //let chart4_4 = document.getElementById('chart4_4');
        if(chart4_1 ){
          chart4_1.style.width = chartWidth; chart4_2.style.width = chartWidth;
          //chart4_3.style.width = chartWidth; chart4_4.style.width = chartWidth;
        }
      },
      cancel(){
        this.typeChooseVisible=false;
      },
      choose(e){
        const parent = e.target.parentNode.parentNode;
        const labels =parent.getElementsByTagName('label');
        if(e.target.className===''){
          e.target.className = 'no';
          labels[0].className = 'no';
        }else{
          e.target.className = '';
          for(let i=1;i<labels.length;i++){
            if(labels[i].className===''){
              this.count++;}
          }
          if(this.count===labels.length-1){
            labels[0].className = '';
          }
          this.count = 0;
        }
      },
      chooseAll(e){
        const parent = e.target.parentNode.parentNode;
        const labels =parent.getElementsByTagName('label');
        this.flag =(labels[0].className==='no')?1:0;/*初始化，判断接下来的点击是否全选*/
        for(let i=0;i<labels.length;i++){
          if(this.flag===0){
            labels[i].className = 'no';
          }else{
            labels[i].className = '';
          }
        }
       /* if(labels[0].className==='no'){this.flag = 1;}
        else{ this.flag = 0;}*/
      },
      open(){
        // 重置日期控件
        this.value2=new Date(this.st*1000);  // 起始时间
        this.value1=new Date(this.et*1000);  // 截止时间
        this.timeRangeSelect=this.timeRangeSelectSave;
        this.timeIntervalSelect=this.timeIntervalSelectSave;
        this.intervalOption=this.intervalOptionSave.concat();
        if (0==this.timeRangeSelect) {
          this.startDateDisable=false;
        } else {
          this.startDateDisable=true;
        }
        console.log('intervalOption:', this.intervalOption);
        //
        this.typeChooseVisible=true;
        auth.checkWeekMode(this);
        this.$nextTick(this.initWeeks);/*不能传参，未封装待优化*/
      },
      initWeeks(){
        const weeks = document.getElementById('weeks');
        const weken = document.getElementById('weken');
        const labels1 = weeks.getElementsByTagName('label');
        const labels2 = weken.getElementsByTagName('label');
        labels1[0].className=(this.weekM1)?'no':'';
        labels2[0].className=(this.weekM2)?'no':'';
        for(let i=1;i< labels1.length;i++){
          labels1[i].className=(this.weekModeSp[i-1])?'no':'';
        }
        for(let i=1;i< labels2.length;i++){
          labels2[i].className=(this.weekModeSp[i+4])?'no':'';
        }
      },

      dateApply(){
        this.dateChange();
        if(this.dayNum2>90){
          let tip = this.$t('dateErr1');
          this.$message.error(tip);
        }else if(this.dayNum2<1){
          let tip = this.$t('dateErr2');
          this.$message.error(tip);
        }else{
          let weekmode = this.checkDate();
          if(weekmode==='nnnnnnn'){
            this.$message({
              type: 'warning',
              message: 'The date should be 1 or more day !'
            });
          }else{
            this.startDate = format.formatterDate4(this.st);
            this.defaultDate =format.formatterDate4(this.et) ;
            let st =  this.startDate.split('-');
            let et = this.defaultDate.split('-');
            this.weekmode = weekmode;
            sessionStorage.setItem('st4',this.st);
            sessionStorage.setItem('et4',this.et);
            this.whichDay =(this.weekmode==='yyyyyyy')?' Everyday':this.whichDay;
            this.timeRange = st[0]+'/'+st[1]+'/'+st[2]+' - '+et[0]+'/'+et[1]+'/'+et[2]+', '+this.$t(this.whichDay);
            sessionStorage.setItem('week4',this.weekmode);
            sessionStorage.setItem('timeRange4',this.timeRange);
            sessionStorage.setItem('timeRangeSelect4',this.timeRangeSelect);
            sessionStorage.setItem('timeIntervalSelect4',this.timeIntervalSelect);
            this.typeChooseVisible=false;
            //this.getData();

            // 保存dashboard报告的日期
            sessionStorage.setItem('st7', this.st);
            sessionStorage.setItem('et7', this.et);
            sessionStorage.setItem('timeRangeSelect7', this.timeRangeSelect);
            // 设置事件报告的时间
            sessionStorage.setItem('st8', this.st);
            sessionStorage.setItem('et8', this.et);
            sessionStorage.setItem('timeRangeSelect8', this.timeRangeSelect);

            // 设置 day by day 的报告
            let daySpan=(this.et-this.st)/86400+1;  // 计算一共有多少天
            let st2=this.et-86400*(7-1);   // 默认
            if (daySpan>7) {
              st2=this.et-86400*(14-1);  // 大于7天， day by day 就改成14天
            }
            sessionStorage.setItem('st2', st2);
            sessionStorage.setItem('et2', this.et);
            // sensor overlay 时间修改
            let st3=this.et-86400*(7-1);   // 默认
            sessionStorage.setItem('st3', st3);
            sessionStorage.setItem('et3', this.et);
            if (!sessionStorage.getItem('week3')) {
              sessionStorage.setItem('week3', 'yyyyyyy');
            }
            // logbook 时间修改
            let st5=this.et-86400*(7-1);   // 默认7天
            if (daySpan>7) {
              st5=this.et-86400*(14-1);  // 大于7天， day by day 就改成14天
            }
            sessionStorage.setItem('st5', st5);
            sessionStorage.setItem('et5', this.et);
            if (!sessionStorage.getItem('week5')) {
              sessionStorage.setItem('week5', 'yyyyyyy');
            }

            // window.location.reload();
            this.$emit('reload')
          }
        }
      },
      dateChange(){
        if(this.value2&&this.value1) {
          this.et = this.value1.getTime()/1000;
          this.st = this.value2.getTime()/1000;
        } else if(!this.value2&&this.value1){
          this.et = this.value1.getTime()/1000;
          let t = this.startDate.split('-');
          this.st = new Date(parseInt(t[2]),parseInt(t[1])-1,parseInt(t[0])).getTime()/1000;
        }else if(!this.value1&&this.value2){
          this.st = this.value2.getTime()/1000;
          let t = this.defaultDate.split('-');
          this.et = new Date(parseInt(t[2]),parseInt(t[1])-1,parseInt(t[0])).getTime()/1000;
        }
        this.dayNum2 = parseInt((this.et-this.st)/86400+1);
        // 设置保存到副本
        this.timeRangeSelectSave=this.timeRangeSelect;
        this.timeIntervalSelectSave=this.timeIntervalSelect;
        this.intervalOptionSave=this.intervalOption.concat();

      },
      startDateChange(){
        let st=this.value2.getTime()/1000
        let daySpan=0;
        if (1==this.timeRangeSelect) {
          daySpan=7;
        } else if (2==this.timeRangeSelect){
          daySpan=14;
        } else if (3==this.timeRangeSelet) {
          daySpan=30;
        } else if (4==this.timeRangeSelect) {
          daySpan=90;
        }
        if (daySpan) {
          let et=st+86400*(daySpan-1);  // 计算截止时间
          this.value1=new Date(et*1000);  // 截止时间控件的变量
          this.defaultDate = format.formatterDate4(et); // 截止时间的显示。
        } else {
          if (st > this.et){
            this.$message.error("Start date bigger than end date.");
            this.value2=new Date(this.st*1000);   // 复位日期的选择
          } else {
            daySpan=(this.et-st)/86400+1;
            console.log('startDateChange:', daySpan);
            if (daySpan>=30){
              this.intervalOption=[[2, this.$t('Week')], [3, this.$t('Month2')]];
              this.timeIntervalSelect=2;
            } else if (daySpan>=14) {
              this.intervalOption=[[1, this.$t('Day')], [2, this.$t('Week')]];
              this.timeIntervalSelect=1;
            } else {
              this.intervalOption=[[1, this.$t('Day')]];
              this.timeIntervalSelect=1;
            }
          }
        }
      },
      endDateChange(){
        let endDate=this.value1;    // 选择的结束时间。
        //this.et=endDate.getTime()/1000;  // unix 时间戳
        let et=endDate.getTime()/1000;  // unix 时间戳
        let daySpan=0;
        if (1==this.timeRangeSelect) {
          daySpan=7;
        } else if (2==this.timeRangeSelect){
          daySpan=14;
        } else if (3==this.timeRangeSelet) {
          daySpan=30;
        } else if (4==this.timeRangeSelect) {
          daySpan=90;
        }
        if (daySpan) {
          let st=et-86400*(daySpan-1);  // 计算起始时间
          this.value2=new Date(st*1000);  // 开始时间控件的变量
          this.startDate = format.formatterDate4(st); // 开始时间的显示。
        } else {
          this.st =this.value2.getTime()/1000; 
          if (et<this.st){
            this.$message.error("End date less than start date.");
            this.value1=new Date(this.et*1000);   // 复位日期的选择
          } else {
            daySpan=(et-this.st)/86400+1;
            console.log('endDateChange:', daySpan);
            if (daySpan>=30){
              this.intervalOption=[[2, this.$t('Week')], [3, this.$t('Month2')]];
              this.timeIntervalSelect=2;
            } else if (daySpan>=14) {
              this.intervalOption=[[1, this.$t('Day')], [2, this.$t('Week')]];
              this.timeIntervalSelect=1;
            } else {
              this.intervalOption=[[1, this.$t('Day')]];
              this.timeIntervalSelect=1;
            }
          }
        }

      },
      checkDate(){
        const weeks = document.getElementById('weeks');
        const weken = document.getElementById('weken');
        if(weeks){
          const labels1 = weeks.getElementsByTagName('label');
          const labels2 = weken.getElementsByTagName('label');
          let  weekmode='';
          if(labels1[0].className===''&&labels2[0].className===''){this.whichDay= 'Everyday';weekmode='yyyyyyy';}
          else{
            this.whichDay=' ';weekmode='';
            for(let i=1;i< labels1.length;i++){
              if(labels1[i].className===''){
                this.whichDay = this.whichDay+' '+labels1[i].innerHTML+'.';
                weekmode = weekmode+'y';
              }else{
                weekmode = weekmode+'n';
              }
            }
            for(let i=1;i< labels2.length;i++){
              if(labels2[i].className===''){
                this.whichDay = this.whichDay+' '+labels2[i].innerHTML+'.';
                weekmode = weekmode+'y';
              }else{
                weekmode = weekmode+'n';
              }
            }
          }
          return weekmode;
        }
      },

      print(){
        let src1 = this.chart4_1.getDataURL();
        let src2 = this.chart4_2.getDataURL();
        sessionStorage.setItem('src4_1',src1);
        sessionStorage.setItem('src4_2',src2);
        sessionStorage.setItem('xDate4',JSON.stringify(this.xDate2));
        sessionStorage.setItem('xTs4',JSON.stringify(this.ts));
        window.open('/#/chart4-print','_blank');
      },

      // 2019-8-14 计算时间区间的参数。
      getTs2(context,st,et){
        console.log('getTs2.1:', context.weekmode);
        let ts =[];  this.xDate=[];
        this.days =(et-st)/86400+1;
        let No = auth.chekcNoDate(context.weekmode);
        let star = format.formatterDate9(st);
        let starDate = new Date(star[0],star[1],star[2]);
        //if(this.days<=7){
        if (1==this.timeIntervalSelect){
          let k=0;
          for(let i=0;i<this.days;i++){
            starDate = new Date(star[0],star[1],star[2]);
            let d =star[2]+i;
            let now = starDate.setDate(d);
            let day = new Date(now).getDay();
            if(No.indexOf(day)===-1){
              ts[k] = [];
              ts[k][0] =  new Date(now).getTime()/1000;
              //startDate每次setDate()都会改变自身，因此使用前初始化
              starDate = new Date(star[0],star[1],star[2]);
              ts[k][1] =  new Date(starDate.setDate(d+1)).getTime()/1000;
              //this.xDate[k] = format.formatterDate4(ts[k][0]);
              this.xDate[k] = format.formatterDate4_1(ts[k][0]);
              k++;
            }
          }
          this.interval = 'd';
        }
        //else if(this.days<=56){
        else if(2==this.timeIntervalSelect){
          //求星期数
          for(let i=0;i<this.days;i++){
            let week =Math.floor(i/7);
            ts[week] =[];
          }
          //求ts
          let k=0;
          for(let i=0;i<this.days;i++) {
            let week =Math.floor(i/7);//确定属于第几星期
            if(i>0&&(Math.floor(i/7)!==Math.floor((i-1)/7))){
              k=0;
            }
            starDate = new Date(star[0],star[1],star[2]);
            let d =star[2]+i;
            let now = starDate.setDate(d);
            let day = new Date(now).getDay();
            if (No.indexOf(day) === -1) {
              ts[week][k] = [];
              ts[week][k][0] = new Date(now).getTime()/1000;
              starDate = new Date(star[0],star[1],star[2]);
              ts[week][k][1] = new Date(starDate.setDate(d+1)).getTime()/1000;
              k++;
            }
          }
          //获取xDate
          let length1 = ts.length,m=0;
          for(let i=0;i<length1;i++){
            let length2 = ts[i].length;
            if(length2===0){
                ts.splice(i,1);
                continue;
            }
            else{
              let sta = format.formatterDate8(ts[i][0][0]);
              let end ='';
              if(length2>1){
                end = format.formatterDate8(ts[i][length2-1][0]);
              }else{
                end=sta;
              }
              this.xDate[m] = sta+'-'+end;
              m++;
            }
          }
          this.interval = 'w';
        }
        else{
          for(let i=0;i<this.days;i++) {
              //算总共几个月
            starDate = new Date(star[0],star[1],star[2]);
            let d =star[2]+i;
            let m = new Date(starDate.setDate(d)).getMonth();
            let month =m-star[1];
            ts[month] =[];
            starDate = new Date(star[0],star[1],star[2]);
          }
          let k=0;
          for(let i=0;i<this.days;i++) {
            starDate = new Date(star[0],star[1],star[2]);
            let d =star[2]+i;
            let now = starDate.setDate(d);
            let m = new Date(now).getMonth();
            let month =m-star[1];
            starDate = new Date(star[0],star[1],star[2]);
            //判断是否是下一个月
            if(i>0&& new Date(now).getMonth()!==new Date(starDate.setDate(d-1)).getMonth()){
                k=0;
            }
            let day = new Date(now).getDay();
            if (No.indexOf(day) === -1) {
              ts[month][k] = [];
              ts[month][k][0] = new Date(now).getTime()/1000;
              //startDate每次setDate()都会改变自身，因此每使用一次都要初始化
              starDate = new Date(star[0],star[1],star[2]);
              ts[month][k][1] = new Date(starDate.setDate(d+1)).getTime()/1000;
              k++;
            }
          }
          //获取xDate
          let length1 = ts.length,m=0;
          for(let i=0;i<length1;i++){
            let length2 = ts[i].length;
            if(length2===0){
              ts.splice(i,1);
              continue;
            }
            else {
              let sta = format.formatterDate8(ts[i][0][0]);
              let end = '';
              if (length2 > 1) {
                end = format.formatterDate8(ts[i][length2 - 1][0]);
              } else {
                end = sta;
              }
              this.xDate[i] = sta + '-' + end;
            }
          }
          this.interval = 'm';
        }
      //  console.log(ts,this.xDate);
        this.xDate2 = this.xDate;
        return ts;
      },
    },
    beforeDestroy(){
      this.chartsDispose();
    },
    created:function() {
      //this.glucose=this.glucoseDefault;
      //this.event=this.eventDefault;
      //sessionStorage.setItem('glucoseDefault', )
      let strGlucose=JSON.stringify(this.glucoseDefault);
      let strEvent=JSON.stringify(this.eventDefault);
      this.glucose=JSON.parse(strGlucose);
      this.event=JSON.parse(strEvent);
    },
    mounted: function () {
      let lang = sessionStorage.getItem('language');
      this.isEn = (lang!=='zh'&&lang !=='hk')?true:false;
      this.isDe = (lang==='de')?true:false;
      this.isIt = (lang==='it')?true:false;
      this.isPo = (lang==='po')?true:false;
      this.isDu = (lang==='du')?true:false;
      this.isFr = (lang==='fr')?true:false;
      this.isSw = (lang==='sw')?true:false;
      this.isCz = (lang==='cz')?true:false;
      this.isMg = (localStorage.getItem('unit')==='mg')?true:false;
      if(sessionStorage.getItem('userType')!=='P'){
        this.uid = parseInt(sessionStorage.getItem('patientId'));
      }else{
        this.uid = parseInt(sessionStorage.getItem('uid'));
      }
      console.log('st4:', sessionStorage.getItem('st4'));
      if(!sessionStorage.getItem('st4')){
        //this.et= new Date().setHours(0,0,0,0)/1000-86400;
        var nd=new Date();
        var cur_day=new Date(nd.getFullYear(), nd.getMonth(), nd.getDate()-1)
        this.et=cur_day/1000;
        var chart_end_time=sessionStorage.getItem('chart_end_time')
        for (var d=0; d<3000; d++) {
          if (this.et > chart_end_time) {
            //this.et -= 24*3600;
            cur_day=new Date(cur_day.getFullYear(), cur_day.getMonth(), cur_day.getDate()-1)
            this.et=cur_day/1000;
          } else {
            break;
          }
        }
        this.st = this.et-86400*6;
        this.weekmode = 'yyyyyyy';
        this.timeRange = format.formatterDate2(this.st)+'-'+format.formatterDate2(this.et)+', '+this.$t(this.whichDay);
      }else{
        this.st = parseInt(sessionStorage.getItem('st4'));
        this.et = parseInt(sessionStorage.getItem('et4'));
        this.weekmode =sessionStorage.getItem('week4');
        this.timeRange =sessionStorage.getItem('timeRange4');  // 读出来的字符串类型的， 注意类型转换。
        this.timeRangeSelect =sessionStorage.getItem('timeRangeSelect4');
        this.timeIntervalSelect =sessionStorage.getItem('timeIntervalSelect4');

        console.log('timeRangeSelect.1:',
          this.timeRangeSelect, typeof(this.timeRangeSelect),
          this.weekmode, typeof(this.weekmode),
          this.timeIntervalSelect, typeof(this.timeIntervalSelect));

        if ('null'==this.timeRangeSelect || 'NaN'==this.timeRangeSelect || !this.timeRangeSelect) {
          this.timeRangeSelect=1;
        }

        console.log('weekmode.1:', this.weekmode, (this.weekmode===null), (!this.weekmode),
          ((''+this.weekmode)=='null'), typeof(this.weekmode));
        if ('null'==this.weekmode || !this.weekmode ) {
          this.weekmode='yyyyyyy';
          console.log('weekmode.2:');
        }
        // 日期分析 粒度， 日，周， 月
        if ('null'==this.timeIntervalSelect || 'NaN'==this.timeIntervalSelect || !this.timeIntervalSelect){
          this.timeIntervalSelect=1;
        } else {
          //this.timeRangeSelect += 0;    // 转换成数字类型。 这种写法不能转换成数字。
          this.timeIntervalSelect=parseInt(this.timeIntervalSelect);
          if (this.timeIntervalSelect==NaN || this.timeIntervalSelect>4) {  // 限制范围
            this.timeIntervalSelect=1;
          }
        }
        console.log('timeRangeSelect.2:', this.timeRangeSelect, this.weekmode, this.timeIntervalSelect);
        if (1==this.timeRangeSelect){   // 7天
          this.intervalOption=[[1, this.$t('Day')]];
          //this.timeIntervalSelect=1;
          //daySpan=7;
          if ('null'==this.timeIntervalSelect){
            this.timeIntervalSelect=1;
          }
        } else if (2==this.timeRangeSelect){  // 14天
          this.intervalOption=[[1, this.$t('Day')], [2, this.$t('Week')]];
          //this.timeIntervalSelect=1;
          //daySpan=14;
          if ('null'==this.timeIntervalSelect){
            this.timeIntervalSelect=1;
          }
        } else if (3==this.timeRangeSelect || 4==this.timeRangeSelect){  // 30天
          this.intervalOption=[[2, this.$t('Week')], [3, this.$t('Month2')]];
          //this.timeIntervalSelect=2;
          //daySpan=30;
          //if (4==this.timeRangeSelect) {
          //  daySpan=90;
          //}
          if ('null'==this.timeIntervalSelect){
            this.timeIntervalSelect=2;
          }
        } else if (0==this.timeRangeSelect){   // 自定义时间， 要判断范围
          let daySpan=(this.et-this.st) / 86400 +1;
          console.log("customize daySpan:", daySpan);
          //if () {
          //}
          if (daySpan>=30){
            this.intervalOption=[[2, this.$t('Week')], [3, this.$t('Month2')]];
            this.timeIntervalSelect=2;
          } else if (daySpan>=14) {
            this.intervalOption=[[1, this.$t('Day')], [2, this.$t('Week')]];
            this.timeIntervalSelect=1;
          } else {
            this.intervalOption=[[1, this.$t('Day')]];
            this.timeIntervalSelect=1;
          }

        }
        // 自定义时可以设置起始时间。
        if (0==this.timeRangeSelect) {
          this.startDateDisable=false;
        } else {
          this.startDateDisable=true;
        }
      }
      // 保存设置的副本， 如果对话框取消， 下次打开对话框时， 使用保存的设置副本
      this.timeRangeSelectSave=this.timeRangeSelect;
      this.timeIntervalSelectSave=this.timeIntervalSelect;
      this.intervalOptionSave=this.intervalOption.concat();

      //
      sessionStorage.setItem('st4',this.st);
      sessionStorage.setItem('et4',this.et);
      sessionStorage.setItem('week4',this.weekmode);
      sessionStorage.setItem('timeRange4',this.timeRange);
      sessionStorage.setItem('timeRangeSelect4',this.timeRangeSelect);
      sessionStorage.setItem('timeIntervalSelect4',this.timeIntervalSelect);
      this.startDate = format.formatterDate4(this.st);
      this.defaultDate =format.formatterDate4(this.et)
      this.value2=new Date(this.st*1000);
      this.value1=new Date(this.et*1000);
      let win = window.innerWidth;
      //this.dialogSize =(win<1500)?'small':'tiny';
      this.getData();

      // 设置Dashboard的时间
      sessionStorage.setItem('st7', this.st);
      sessionStorage.setItem('et7', this.et);
      sessionStorage.setItem('timeRangeSelect7', this.timeRangeSelect);
      // 设置事件报告的时间
      sessionStorage.setItem('st8', this.st);
      sessionStorage.setItem('et8', this.et);
      sessionStorage.setItem('timeRangeSelect8', this.timeRangeSelect);

      // 设置 day by day 报告的时间
      let daySpan=(this.et-this.st)/86400+1;  // 计算一共有多少天
      let st2=this.et-86400*(7-1);   // 默认
      if (daySpan>7) {
        st2=this.et-86400*(14-1);  // 大于7天， day by day 就改成14天
      }
      sessionStorage.setItem('st2', st2);
      sessionStorage.setItem('et2', this.et);
      // sensor overlay 时间修改
      let st3=this.et-86400*(7-1);   // 默认
      sessionStorage.setItem('st3', st3);
      sessionStorage.setItem('et3', this.et);
      if (!sessionStorage.getItem('week3')) {
        sessionStorage.setItem('week3', 'yyyyyyy');
      }
      // logbook 时间修改
      let st5=this.et-86400*(7-1);   // 默认7天
      if (daySpan>7) {
        st5=this.et-86400*(14-1);  // 大于7天， day by day 就改成14天
      }
      sessionStorage.setItem('st5', st5);
      sessionStorage.setItem('et5', this.et);
      if (!sessionStorage.getItem('week5')) {
        sessionStorage.setItem('week5', 'yyyyyyy');
      }


      let that = this;
      window.onresize = function () {
        that.handleResize();
        if(that.chart4_1){
          that.chart4_1.resize(); that.chart4_2.resize();
          //that.chart4_3.resize(); that.chart4_4.resize();
        }
      }
    },

  }
</script>

<style scoped>
  .chart-container {
    width:100%;
    float: left;
    font-family:SFUIText-Regular;
    font-size:14px;
    color:#282828;
    letter-spacing:-0.34px;
  }
  .Hcp-main-header{
    width:97%;
    height:40px;
    margin:0 auto;
    font-family:SFUIText-Regular;
    font-size:18px;
    color:#282828;
  }
  .main-header-left{
    float: left;
    height:20px;
    line-height: 20px;
    margin-top:10px;
    border-left: 2px solid #005dac;
  }
  .main-header-left span{
    margin-left:10px;
  }
  .main-header-right{
    float: right;
    width:80%;
    height:30px;
    line-height: 30px;
    margin-right: 1%;
  }
  .main-header-right p{
    float: right;
    margin-right:15px;
    margin-top:2px;
  }
  .main-header-right .time{
    font-size:16px;
    letter-spacing:-0.39px;
    color:#0082d2;
    margin-left: 10px;
  }
  .main-header-right button{
    float: right;
    border-radius:100px;
    box-shadow:0 3px 4px 0 #e8f3ff;
    background: #fff;
    border: 1px solid #a3a3a3;
    width:110px;
    height:26px;
    line-height: 26px;
    outline: none;
    margin-top:4px;
    margin-left: 3%;
    cursor: pointer;
  }
  button:hover{
    background-image:linear-gradient(90deg, #42c3fd 0%, #55adf8 100%);
    color:#fff;
  }
  .main-header-right .set{
    margin-left: 0;
  }
  button span{
    font-family:SFUIText-Regular;
    font-size: 16px;
    letter-spacing:-0.39px;
  }
  .small-hr{
    background:#e6e8ea;
    width:97%;
    height:1px;
    margin:10px auto 20px;
    border:none;
  }
  .spe-hr{
    margin-bottom:20px ;
  }

  .chart-container .graph{
    width:100%;
    height:170px;
    margin-bottom: 15px;
  }


  /*对话框*/
  #dialog-form2{
    font-family:SFUIText-Regular;
  }
  .patientList-dialog-title{
    float: left;
    background-image:linear-gradient(90deg, #38bcf7 0%, #3fa1f4 100%);
    height:45px;
    line-height: 50px;
    width:100%;
    margin:-20px 30px 0 -20px;
    font-size:18px;
    color:#ffffff;
    letter-spacing:-0.43px;
    position: absolute;
  }
  .patientList-dialog-title span{
    margin-left: 42px;
  }
  .patientList-dialog-title img{
    float: right;
    margin-top:16px;
    cursor: pointer;
    margin-right: 10px;
  }
  .dialog-body{
    width:100%;
    margin-top: 25px;
  }

  .patientList-small-hr{
    background:#dedede;
    width:94%;
    height:1px;
    margin:20px 0 10px 10px;
    border:none;
    clear: both;
  }
  .dialog-body .time-range{
    margin-left: 20px;
    height:35px;
    line-height: 35px;
  }
  .time-range p{
    float: left;
    font-family:SFUIText-Regular;
    font-size:18px;
    color:#282828;
    letter-spacing:-0.44px;
    text-align:center;
    margin-right: 20px;
  }
  .time-range .block{
    float: left;
  }
  .time-range .date{
    float: left;
    width:20%;
    height:35px;
    line-height: 35px;
    font-size: 16px;
    margin-right: 15%;
  }
  .el-date-editor.el-input{
    width:125px;
  }

  .weeks{
    width:92%;
    margin:0 auto;
    margin-top: 30px;
  }
  .weken{
    margin-top: 20px;
    margin-bottom: 30px;
  }
  .weeks span{
    font-family:SFUIText-Regular;
    font-size:16px;
    color:#6d6d6d;
    letter-spacing:-0.39px;
    text-align:left;
    margin-left: 4%;
  }
  .weeks .tittle{
    margin: 0 7% 0 0;
    display: block;
    float: left;
    margin-bottom: 10px;
  }
  .weeks label{
    background: url("../../assets/select yes.png") left 1px no-repeat;
    cursor: pointer;
    padding-left: 18px;
  }
  .weeks .no{
    background: url("../../assets/select no.png") left 1px no-repeat;
  }

  .dialog-footer{
    margin:-25px auto 15px;
    width:70%;
  }
  .dialog-footer button{
    background-image:linear-gradient(90deg, #42c3fd 0%, #55adf8 100%);
    box-shadow:0 3px 4px 0 #c6e1ff;
    color:#fff;
    margin:0 auto;
    border-radius:100px;
    width:40%;
    height:30px;
    border:none;
    outline: none;
    cursor: pointer;
  }
  .dialog-footer .cancelButton{
    background: transparent;
    border:1px solid #009fdf;
    color: #282828;
    outline: none;
    margin-left: 7%;
  }
  .zh2 p{
    font-size: 16px;
  }
  .zh3 span{
    font-size: 15px;
  }
  .weeks .zh4{
    margin-right: 10px;
  }
  .weeks .zh5{
    margin-right: 25px;
  }
  .weeks .de5{
    margin-right: 21px;
  }
  .weeks .it5{
    margin-right: 15px;
  }
  .weeks .it2{
    margin-left: 3.8%;
  }
  .weeks .po5{
    margin-right: 24px;
  }
  .weeks .po2{
    margin-left: 4.1%;
  }
  .weeks .du5{
    margin-right: 54px;
  }
  .weeks .du2{
    margin-left: 4.6%;
  }
  .weeks .fr3 {
    margin-left: 3%;
  }
  .weeks .sw5{
    margin-right: 51px;
  }
  .weeks .sw2{
    margin-left: 5%;
  }
  .weeks .cz5{
    margin-right: 66px;
  }
  .weeks .cz2{
    margin-left: 4%;
  }

  .statics{
    clear: both;
    margin-top: 10px;
    margin-bottom: 55px;
  }
  .statics p{
    font-family:SFUIText-Regular;
    font-size:14px;
    color:#282828;
    letter-spacing:-0.27px;
    margin-left: 4%;
  }
  .statics-table{
    width: 94%;
    margin:10px auto 0;
    border:1px solid #747474;
    font-family:SFUIText-Regular;
    border-collapse: collapse;
    text-align:center;
  }
  .de2{
    word-wrap: break-word;
    word-break: break-all;
  }
  .statics-table td{
    font-size:13px;
    height:15px;
  }
  .statics-table .td1{
    border-bottom:1px solid rgba(116,116,116,0.34);
    border-right:1px solid rgba(116,116,116,0.34);
  }
  .statics-table .td2{
    border-bottom:1px solid rgba(116,116,116,0.34);
  }
  .statics-table .td3{
    border-right:1px solid rgba(116,116,116,0.34);
  }
  .spe-statics{
    margin-bottom: 10px;
  }
  .spe-statics table{
    table-layout: fixed;
  }
  .value_percent_cell {
    display: block;
    float: left;
    width:50%;
  }
  .select-interval-wrap {
    margin-bottom:10px;
    padding:18px;
    color:black;
    *font-weight: bold;
    font-size:16px;
  }
  .select-interval-wrap p {
    float:left;
    margin-right:20px;
  }

  .select-interval-wrap select{
    float:left;
  }

  .select-interval-wrap .select-timerange{
    width:70px;
    height:30px;
    margin-right: 80px;
  }

  .select-interval-wrap .select-interval{
    width:60px;
    height:30px;
  }

</style>



// WEBPACK FOOTER //
// chart4.vue?07e4b14e